import React, { useEffect, useState, useContext } from 'react';
import { X, Loader2, ArrowLeft, Mail } from 'lucide-react';
import { authService } from '../../services/auth';
import { ToastContext } from '../../App';
const LoginModal = ({
  isOpen,
  onClose,
  onRegisterClick,
  pendingAnalysis = false,
  isRelogin = false
}) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isForgotPassword, setIsForgotPassword] = useState(false);
  const [isResetEmailSent, setIsResetEmailSent] = useState(false);
  const [forgotPasswordEmail, setForgotPasswordEmail] = useState('');
  const [error, setError] = useState('');
  const [isMagicLinkView, setIsMagicLinkView] = useState(false);
  const [magicLinkSent, setMagicLinkSent] = useState(false);
  const [magicLinkEmail, setMagicLinkEmail] = useState('');
  const {
    addToast
  } = useContext(ToastContext);
  useEffect(() => {
    if (isOpen) {
      // Clear error messages when modal is opened
      setError('');
    }
  }, [isOpen]);
  if (!isOpen) return null;
  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    try {
      await authService.login(email, password);
      setIsLoading(false);
      onClose();
      // Show toast notification
      addToast('success', 'Login realizado com sucesso!');
      // Dispatch storage event to update authentication state
      window.dispatchEvent(new Event('storage'));
    } catch (error) {
      setIsLoading(false);
      setError(error.response?.data?.message || 'Erro ao fazer login. Verifique suas credenciais.');
    }
  };
  const handleForgotPasswordSubmit = async e => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    try {
      // Use the correct method for password reset
      await authService.requestPasswordReset(forgotPasswordEmail);
      setIsLoading(false);
      setIsResetEmailSent(true);
    } catch (error) {
      setIsLoading(false);
      setError(error.response?.data?.message || 'Erro ao solicitar redefinição de senha. Verifique seu email.');
    }
  };
  const handleMagicLinkSubmit = async e => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    try {
      await authService.requestMagicLink(magicLinkEmail);
      setIsLoading(false);
      setMagicLinkSent(true);
      // Show toast notification
      addToast('success', 'Link de acesso enviado com sucesso!');
    } catch (error) {
      setIsLoading(false);
      setError(error.response?.data?.message || 'Erro ao enviar magic link. Verifique seu email.');
    }
  };
  const handleBackToLogin = () => {
    setIsForgotPassword(false);
    setIsResetEmailSent(false);
    setIsMagicLinkView(false);
    setMagicLinkSent(false);
    setError('');
  };
  return <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50" data-id="element-32" data-mp="2ykygm1s9gzgi">
      <div className="relative w-full max-w-md p-6 mx-4 bg-white rounded-lg shadow-xl flex flex-col" data-id="element-33" data-mp="33ji4i7qf0lbi">
        <button onClick={onClose} className="absolute top-4 right-4 text-gray-500 hover:text-gray-700" aria-label="Close" disabled={isLoading} data-id="element-34" data-mp="rw66mxecy95c">
          <X size={20} data-id="element-35" data-mp="i2fpkdkk90zo" />
        </button>
        <div className="flex flex-col" data-id="element-36" data-mp="d67cr6tu5jvo">
          {isForgotPassword ? <>
              <div className="flex items-center mb-6" data-id="element-37" data-mp="94dgdaqob21b">
                <button onClick={handleBackToLogin} className="mr-2 text-gray-500 hover:text-gray-700" disabled={isLoading} data-id="element-38" data-mp="91r7n7s1qghi">
                  <ArrowLeft size={20} data-id="element-39" data-mp="3vbajevzga3y7" />
                </button>
                <h2 className="text-2xl font-bold text-gray-900" data-id="element-40" data-mp="3qd0p0nljv7dn">
                  Recuperar senha
                </h2>
              </div>
              {isResetEmailSent ? <div className="flex flex-col justify-center space-y-4" data-id="element-41" data-mp="1ok2tgk0e20p0">
                  <div className="p-4 bg-green-50 text-green-800 rounded-md" data-id="element-42" data-mp="1oirl06w004rk">
                    <p data-id="element-43" data-mp="1wm22qt9l0qfe">
                      Se o email existir, enviamos um link de recuperação de
                      senha para <strong data-id="element-44" data-mp="21i0vsu5uuwm5">{forgotPasswordEmail}</strong>.
                    </p>
                    <p className="mt-2" data-id="element-45" data-mp="1mmukbrnzq5lf">
                      Verifique sua caixa de entrada e siga as instruções para
                      redefinir sua senha.
                    </p>
                  </div>
                  <button onClick={() => {
              handleBackToLogin();
              addToast('success', 'Link de recuperação enviado com sucesso!');
            }} className="w-full py-2 text-white bg-[#1649ff] rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2" data-id="element-46" data-mp="1dspt374y2s5d">
                    Voltar para o login
                  </button>
                </div> : <form onSubmit={handleForgotPasswordSubmit} className="flex flex-col" data-id="element-47" data-mp="g9hoqs6x9d88">
                  <div data-id="element-48" data-mp="p9o28e2med7e">
                    <p className="text-sm text-gray-600 mb-4" data-id="element-49" data-mp="paz2i3wux2tr">
                      Digite seu e-mail abaixo. Enviaremos um link para que você
                      possa criar uma nova senha.
                    </p>
                    {error && <div className="p-3 bg-red-50 text-red-700 rounded-md mb-4" data-id="element-50" data-mp="z5r2fedww1rp">
                        {error}
                      </div>}
                    <div data-id="element-51" data-mp="17zvycc7wk3e3">
                      <label htmlFor="forgotPasswordEmail" className="block mb-2 text-sm font-medium text-gray-700" data-id="element-52" data-mp="182i88ii9muzh">
                        Email
                      </label>
                      <input type="email" id="forgotPasswordEmail" value={forgotPasswordEmail} onChange={e => setForgotPasswordEmail(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#1649ff]" required disabled={isLoading} autoComplete="username" data-id="element-53" data-mp="1d09xt5vfu50i" />
                    </div>
                  </div>
                  <button type="submit" className="w-full py-2 mt-6 text-white bg-[#1649ff] rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 flex items-center justify-center" disabled={isLoading} data-id="element-54" data-mp="yb5avvntn6kh">
                    {isLoading ? <>
                        <Loader2 size={18} className="mr-2 animate-spin" data-id="element-55" data-mp="393gcsj1t8lpm" />
                        Processando...
                      </> : 'Recuperar senha'}
                  </button>
                </form>}
            </> : isMagicLinkView ? <>
              <div className="flex items-center mb-6" data-id="element-56" data-mp="2runh1a6dub0y">
                <button onClick={handleBackToLogin} className="mr-2 text-gray-500 hover:text-gray-700" disabled={isLoading} data-id="element-57" data-mp="2mvsx24woigf9">
                  <ArrowLeft size={20} data-id="element-58" data-mp="3fjgitn9ord3h" />
                </button>
                <h2 className="text-2xl font-bold text-gray-900" data-id="element-59" data-mp="3fi5d3hwojv9q">
                  Login com Magic Link
                </h2>
              </div>
              {magicLinkSent ? <div className="flex flex-col justify-center space-y-4" data-id="element-60" data-mp="36j0gih4oic07">
                  <div className="p-4 bg-green-50 text-green-800 rounded-md" data-id="element-61" data-mp="1z6rp0irrd7ai">
                    <p data-id="element-62" data-mp="1v3lgf4h6b40v">
                      Enviamos um link de acesso para{' '}
                      <strong data-id="element-63" data-mp="3u94qpuyyqw83">{magicLinkEmail}</strong>.
                    </p>
                    <p className="mt-2" data-id="element-64" data-mp="3ub7qv7tty5qj">
                      Verifique sua caixa de entrada e clique no link para fazer
                      login.
                    </p>
                  </div>
                  <button onClick={handleBackToLogin} className="w-full py-2 text-white bg-[#1649ff] rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2" data-id="element-65" data-mp="3lajcgc0iy3d4">
                    Voltar para o login
                  </button>
                </div> : <form onSubmit={handleMagicLinkSubmit} className="flex flex-col" data-id="element-66" data-mp="8156itio168h">
                  <div data-id="element-67" data-mp="10qc49qaaprso">
                    <p className="text-sm text-gray-600 mb-4" data-id="element-68" data-mp="10psp2hc15hic">
                      Digite seu e-mail abaixo. Enviaremos um link para que você
                      possa acessar sua conta sem senha.
                    </p>
                    {error && <div className="p-3 bg-red-50 text-red-700 rounded-md mb-4" data-id="element-69" data-mp="1etroa21on1mv">
                        {error}
                      </div>}
                    <div data-id="element-70" data-mp="1okchtb2i1fyx">
                      <label htmlFor="magicLinkEmail" className="block mb-2 text-sm font-medium text-gray-700" data-id="element-71" data-mp="1onrxog3zyt1e">
                        Email
                      </label>
                      <input type="email" id="magicLinkEmail" value={magicLinkEmail} onChange={e => setMagicLinkEmail(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#1649ff]" required disabled={isLoading} autoComplete="username" data-id="element-72" data-mp="rvwp5643eqhl" />
                    </div>
                  </div>
                  <button type="submit" className="w-full py-2 mt-6 text-white bg-[#1649ff] rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 flex items-center justify-center" disabled={isLoading} data-id="element-73" data-mp="3p3fjt9fj650p">
                    {isLoading ? <>
                        <Loader2 size={18} className="mr-2 animate-spin" data-id="element-74" data-mp="368qsvqom5v4j" />
                        Processando...
                      </> : 'Enviar Magic Link'}
                  </button>
                </form>}
            </> : <>
              <h2 className="mb-6 text-2xl font-bold text-center text-gray-900" data-id="element-75" data-mp="um2ht7pazocc">
                {isRelogin ? 'Faça login novamente' : 'Entrar'}
              </h2>
              <div className="flex flex-col" data-id="element-76" data-mp="pkn11ru5s3zr">
                {pendingAnalysis && <div className="mb-4 p-3 bg-blue-50 text-blue-800 rounded-md" data-id="element-77" data-mp="y1dvz1bluwdm">
                    Faça login para continuar com a análise da sua marca.
                  </div>}
                {error && <div className="mb-4 p-3 bg-red-50 text-red-700 rounded-md" data-id="element-78" data-mp="1buvb89x9dmxu">
                    {error}
                  </div>}
                <form onSubmit={handleSubmit} className="space-y-4 px-0.5" data-id="element-79" data-mp="f5xg2qlljn05">
                  <div data-id="element-80" data-mp="j5ftl1b38vsy">
                    <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-700" data-id="element-81" data-mp="j6psfsprm80n">
                      Email
                    </label>
                    <input type="email" id="email" name="email" value={email} onChange={e => setEmail(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#1649ff] text-gray-900" required disabled={isLoading} autoComplete="username" data-id="element-82" data-mp="t2aprdjw2k42" />
                  </div>
                  <div data-id="element-83" data-mp="1ju87yx7zpqst">
                    <label htmlFor="password" className="block mb-2 text-sm font-medium text-gray-700" data-id="element-84" data-mp="1jv14l5d8izx8">
                      Senha
                    </label>
                    <input type="password" id="password" name="password" value={password} onChange={e => setPassword(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#1649ff] text-gray-900" required disabled={isLoading} autoComplete="current-password" data-id="element-85" data-mp="r3pvj5ldmd2q" />
                  </div>
                  <div className="flex justify-between items-center" data-id="element-86" data-mp="2ou6brz349ph8">
                    <button type="button" onClick={() => setIsForgotPassword(true)} className="text-sm text-[#1649ff] hover:underline" disabled={isLoading} data-id="element-87" data-mp="2a59x3j6k1e7n">
                      Esqueceu a senha?
                    </button>
                    <button type="button" onClick={() => setIsMagicLinkView(true)} className="text-sm text-[#1649ff] hover:underline flex items-center" disabled={isLoading} data-id="element-88" data-mp="37rquspj79ttx">
                      <Mail size={14} className="mr-1" data-id="element-89" data-mp="1icj9fx2xsxu0" />
                      Login com Magic Link
                    </button>
                  </div>
                </form>
                <div className="mt-6" data-id="element-90" data-mp="22mkh9btrz8is">
                  <button type="submit" onClick={handleSubmit} className="w-full py-2 text-white bg-[#1649ff] rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 flex items-center justify-center" disabled={isLoading} data-id="element-91" data-mp="22nn51avswuuh">
                    {isLoading ? <>
                        <Loader2 size={18} className="mr-2 animate-spin" data-id="element-92" data-mp="2lik82jb0o60s" />
                        Processando...
                      </> : isRelogin ? 'Fazer login' : 'Entrar'}
                  </button>
                  <div className="mt-4 text-center" data-id="element-93" data-mp="107bvtodpf6k7">
                    <p className="text-sm text-gray-600" data-id="element-94" data-mp="108wot9kdehfy">
                      Não tem uma conta?{' '}
                      <button onClick={onRegisterClick} className="text-[#1649ff] hover:underline" disabled={isLoading} data-id="element-95" data-mp="w4oy56ucqrf3">
                        Criar conta
                      </button>
                    </p>
                  </div>
                </div>
              </div>
            </>}
        </div>
      </div>
    </div>;
};
export default LoginModal;